import classNames from "classnames";
import React from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import { AdminUploadIcon } from "../../AscIcons";
import styles from "../AscAdminCSVUploader.module.scss";

interface IAscUploadArea {
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T;
  className?: string;
  icon?: React.ReactNode;
  withBr?: boolean;
  iconClassName?: string;
  textClassName?: string;
}

export default function AscUploadArea({
  getRootProps,
  getInputProps,
  className,
  icon,
  withBr = true,
  iconClassName,
  textClassName,
}: IAscUploadArea) {
  return (
    <div {...getRootProps()} className={classNames(styles.dropzone, className)}>
      <input {...getInputProps()} />

      <div className={styles.dropzoneLabel}>
        <span className={classNames(styles.icon, iconClassName)}>
          {icon ? icon : <AdminUploadIcon />}
        </span>

        <div className={classNames(styles.text, textClassName)}>
          Drop files here to upload {withBr ? <br /> : null} or{" "}
          <span className={styles.link}>choose file</span>
        </div>
      </div>
    </div>
  );
}
